import Api from "./api";



export default new class GroupService extends Api {
    prefix = "group";

    get_targets_groups_by_report_id(report_id) {
        return this.api('get', '/targets/' + report_id)
    }
};